import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Footer from "./Components/Footer/Footer.tsx";
import Header from "./Components/Header/Navbar.tsx";
import ProtectedRoute from "./Components/ProtectedRoute.tsx";
import ScrollToTop from "./Components/scroll-button/ScrollToTop.tsx";
import ShoppingCart from "./Components/shopping-cart/ShoppingCart.tsx";
import About from "./Pages/About.tsx";
import AdminDashboard from "./Pages/admin/AdminDashboard.tsx";
import AdminLogin from "./Pages/admin/AdminLogin.tsx";
import Contact from "./Pages/Contact.tsx";
import Home from "./Pages/Home.tsx";
import NotFound from "./Pages/NotFound.tsx";
import ProductDetails from "./Pages/ProductDetails.tsx";
import Shop from "./Pages/Shop.tsx";
import TermsConditions from "./Pages/TermsConditions.tsx";
import MetaPixelTracker from "./utils/MetaPixelTracker.js";

const AppRoutes = () => {
  const location = useLocation();
  const hideHeaderFooter = location.pathname.startsWith("/admin");

  return (
    <div className="siteShell">
      {!hideHeaderFooter && <Header />}
      <div className="siteMain">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/terms" element={<TermsConditions />} />
          <Route path="/cart" element={<ShoppingCart />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!hideHeaderFooter && <Footer />}
      <Toaster />
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <MetaPixelTracker />
    <ScrollToTop />
    <AppRoutes />
  </BrowserRouter>
);

export default App;
